import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter, useRouteError, Outlet } from 'react-router-dom';
import { TitleProvider } from '@arema/components/Hooks'
import { Header, Toast } from 'react-frontier';
import { AccountCreate, Auth, PasswordComplete, RecoverPassword } from './screens'
import { AuthProvider } from './AuthHooks';
import { initReactI18next, useTranslation } from 'react-i18next';
import { addCommas } from '@arema/components/Util';
import i18n from 'i18next';
import Locale from '@arema/components/src/locale';
import 'frontier-css/css/frontier.css';
import ForgotPassword from './screens/ForgotPassword';

i18n.use(initReactI18next).use(Locale('auth')).init({
	fallbackLng: 'es',
	interpolation: {
		escapeValue: false,
	}
});

i18n.services.formatter.addCached('commas', (lng, options: { fixed: boolean, hideZero: boolean })=>{
	return val=>{
		return addCommas(val, options.fixed!==false, options.hideZero===true);
	}
})

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

var ErrorElement = ()=>{
	const error = (useRouteError() as any);
	return <Header
		text={error.status}
		subtext={error.status===404 ? 'Página no encontrada' : `Hubo un error inesperado. (PBL-LCL-${error.status})`}
		style={{ fontSize: 100 }}
		subheaderStyle={{ fontSize: 20 }}
		containerStyle={{ marginTop: 20 }}
	/>
}

var SiteContainer = (props: { outlet: JSX.Element })=>{
	return <TitleProvider suffix='AREMA Ticket'>
		<AuthProvider>
			{props.outlet}
		</AuthProvider>
	</TitleProvider>
}

const Router = createBrowserRouter([{
	path: '/complete',
	errorElement: <SiteContainer outlet={<ErrorElement />} />,
	element: <SiteContainer outlet={<PasswordComplete />} />,
}, {
	path: '/forgot',
	element: <SiteContainer outlet={<ForgotPassword />} />
}, {
	path: '/recover',
	element: <SiteContainer outlet={<RecoverPassword />} />
}, {
	path: '/create',
	element: <SiteContainer outlet={<AccountCreate />} />
}, {
	path: '*',
	errorElement: <SiteContainer outlet={<ErrorElement />} />,
	element: <SiteContainer outlet={<Auth />} />,
}]);

var Root = ()=>{
	return <Toast.Provider>
		<RouterProvider router={Router} />
	</Toast.Provider>
}

root.render(<Root />);